import TokenTextarea from './token_textarea';

export default TokenTextarea;
